import React, { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";

function InputTextField({ subCategoryId, subCategoryDefinition, columnToUpdate, updateKpiData }) {
  const [fieldValue, setFieldValue] = useState(subCategoryDefinition || "");

  useEffect(() => {
    setFieldValue(subCategoryDefinition);
  }, [subCategoryDefinition]);

  if (!subCategoryId) return null;

  return (
    <TextField
      id="outlined-multiline-flexible"
      label="Definition"
      multiline
      maxRows={4}
      value={fieldValue}
      onChange={(e) => setFieldValue(e.target.value)}
      onBlur={() => updateKpiData({ newValue: fieldValue, subCategoryId, columnToUpdate })}
      sx={{
        width: "225px",
      }}
    />
  );
}

export default InputTextField;
